<template>
  <div class="large-notice">
    <BaseIcon v-if="success" name="check-circle" class="large-notice__icon" />
    <component :is="titleTag" class="large-notice__title">{{ icon }} {{ title }}</component>
    <div class="large-notice__subtitle">{{ subtitle }}</div>

    <div class="large-notice__buttons">
      <BaseButton
        class="large-notice__secondary"
        @click.native="secondButtonClick"
        v-if="secondButtonText"
        is-secondary
      >
        {{ secondButtonText }}
        <BaseIcon :name="secondButtonIcon" v-if="secondButtonIcon" />
      </BaseButton>
      <BaseButton @click.native="mainButtonClick" v-if="buttonText" has-icon-right>
        {{ buttonText }}
        <BaseIcon :name="buttonIcon" v-if="buttonIcon" />
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'LargeNotice',
  components: {
    BaseButton,
    BaseIcon,
  },
  props: {
    icon: String,
    title: String,
    // Tag used for the title. Defaults to a plain div; pass a heading (e.g. "h1")
    // where the notice is the page's main heading, for a correct heading outline.
    titleTag: {
      type: String,
      default: 'div',
    },
    subtitle: String,
    buttonText: {
      type: String,
      required: false,
    },
    secondButtonText: {
      type: String,
      required: false,
    },
    buttonIcon: {
      type: String,
      required: false,
    },
    secondButtonIcon: {
      type: String,
      required: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    mainButtonClick() {
      this.$emit('click');
    },
    secondButtonClick() {
      this.$emit('second-button-click');
    },
  },
};
</script>

<style lang="scss">
.large-notice {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  &__icon {
    color: $color-green;
    width: 68px;
    height: 68px;
  }

  &__title {
    color: $color-normal;
    font-size: 2rem;
    font-weight: bold;
    margin: 1rem 0;
  }

  &__subtitle {
    color: $color-normal-pale;
    font-size: 1.125rem;
    font-family: Raleway;
    font-size: 1.125rem;
    font-weight: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    font-stretch: normal;
    margin-bottom: 1rem;
    margin-top: 15px;
  }

  &__buttons {
    display: flex;
    margin-top: 15px;
  }

  &__secondary {
    margin-right: 15px;
  }
}
</style>
